import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../../js/stores/language.js';
import user from '../../../js/stores/user.js';
import car from '../../../js/stores/car.js';
import contact from '../../../js/stores/contact.js';
import carLoanIssue from '../../../js/stores/car-loan-issue.js';
function framework7Component(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var carLoanIssueList = [];
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var loanIssueList;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return carLoanIssue.dispatch('getCurrentLoanedIssues');
        case 1:
          loanIssueList = _context.sent;
          if (loanIssueList.status !== undefined && loanIssueList.status !== 200) console.log(loanIssueList.data.messages.error);else carLoanIssueList = loanIssueList;
          $update();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var goCarLoanIssueEdit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var anchor, carLoanIssueId, CarLoanIssueItem, obj;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            anchor = e.target.closest("a");
            carLoanIssueId = anchor.dataset.carLoanIssueId;
            CarLoanIssueItem = carLoanIssueList.filter(function (item) {
              return item.CarLoanIssueId == carLoanIssueId;
            })[0];
            obj = {
              props: CarLoanIssueItem
            };
            $f7.views.main.router.navigate('/car-loan-issue-edit/', obj);
            $update();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function goCarLoanIssueEdit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="car-loan-issue-dashboard">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">${locale.translate('admin.sections.refund.panelTitle')}</div>
    </div>
  </div>
  <div class="page-content">
    <div id="container" class="center-content">
      <div class="list media-list list-outline-ios list-strong-ios list-dividers-ios">
        <ul>
        ${carLoanIssueList.length > 0 && $h`
        ${carLoanIssueList.map((item) => $h`
          <li>
            <a class="item-link item-content popup-open" data-popup=".car-loan-issue-popup" @click="${goCarLoanIssueEdit}" data-car-loan-issue-id="${item.CarLoanIssueId}">
              <div class="item-inner" >
                <div class="item-title-row">
                  <div class="item-title">${locale.translate('admin.sections.refund.loanTag')}: ${item.CarLoanTag}</div>
                  <div class="item-after"><i class="icon material-symbols-outlined color-green">balance</i>${locale.translate('general.decide')}</div>
                </div>
                <div class="item-text">
                  <strong>${locale.translate('general.car')}:</strong> ${item.CarManufacturerName} ${item.CarModel} ${item.CarYear}<br/>
                  <strong>${locale.translate('loan.dashboard.lender')}:</strong> ${item.LenderName} | <strong>${locale.translate('loan.dashboard.borrower')}:</strong> ${item.BorrowerName}
                </div>
              </div>
            </a>
          </li>
        `)}
        `}
        </ul>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = '7f6d8ecad8';
export default framework7Component;